/**
 * O DICIONARIO DO CHASSI DE ENTRADA, em ingles.
 *
 * ELE MANDOU EM 08/09/2026: "NO EN TEM QUE TRADUZIR TODO O CONTEUDO DO MENU EXCETO NO NOME
 * DO APP", e completou: "QUE E UMA MARCA".
 *
 * POR QUE ELE MORA AQUI, E NAO EM CADA PRODUTO, e a razao esta escrita no proprio mecanismo
 * (`packages/i18n/src/index.ts`): "cada pacote e cada produto chama isto com as proprias
 * frases, em vez de existir um arquivo gigante central". Estas dezesseis sao do CHASSI: elas
 * aparecem identicas na tela de entrada de todo produto, e escritas em cada `en.ts` de app
 * seriam a mesma traducao em tres lugares. O terceiro envelheceria, e o produto que nascesse
 * depois nasceria sem nenhuma delas.
 *
 * MEDIDO EM 08/09/2026, antes de escrever: com o idioma em EN, sobravam 13 frases em
 * portugues no VOE, 11 no medicina e 11 no admin. SETE apareciam nos tres, e sao justamente
 * as do chassi.
 *
 * A CHAVE E A FRASE EM PORTUGUES, como em toda esta casa. Duas consequencias praticas:
 *   1. o texto continua legivel dentro do componente, sem codigo no meio do JSX;
 *   2. frase sem traducao cadastrada DEGRADA para o portugues, que e legivel, em vez de
 *      virar `login.botao.entrar` na tela.
 *
 * O QUE NAO ENTRA AQUI, e a lista e curta e deliberada:
 *   · O NOME DO PRODUTO. Ele e MARCA, e marca nao se traduz: "VOE" e "VOE" em qualquer
 *     idioma, e traduzi-lo produziria um produto que nao existe. Ele nem passa por `t()`:
 *     a tela le `produto.nome` direto.
 *   · O NOME DA PLATAFORMA. `Complexity Digital Systems` vem de `@complexity/brand`, pelo
 *     mesmo motivo.
 *   · O CONTEUDO DE CADA PRODUTO (titulo, subtitulo, paragrafos, selos, itens de IA). Ele
 *     e declarado no manifesto daquele produto, e traduzido no `en.ts` DELE.
 */
import type { Dicionario } from '@complexity/i18n';

export const EN_CHASSI_LOGIN: Dicionario = {
  // O formulario.
  'E-mail': 'Email',
  Senha: 'Password',
  Entrar: 'Sign in',
  'Entrando...': 'Signing in...',
  'Entrar com Google': 'Sign in with Google',
  'ou entre com e-mail e senha': 'or sign in with email and password',
  // A frase de instrucao responde a pergunta que toda tela de sistema fechado levanta, e a
  // traducao precisa manter isso: quem le em ingles tambem precisa saber que NAO se cadastra
  // sozinho aqui.
  'Entre com a sua conta Google, ou com o e-mail e a senha que o administrador cadastrou para você.':
    'Sign in with your Google account, or with the email and password your administrator set up for you.',

  // O botao do olho. O rotulo diz o que o clique VAI FAZER, e nao o estado atual, e a
  // traducao preserva isso.
  'Mostrar senha': 'Show password',
  'Ocultar senha': 'Hide password',

  // O caminho ate a apresentacao do produto.

  // O rodape legal.
  //
  // O NUMERO DA LEI NAO SE TRADUZ, e isto e regra do dominio e nao escolha de estilo: a lista
  // `NAO_TRADUZIR` do mecanismo diz "nome de lei, de artigo e de norma". A LGPD e a Lei
  // 13.709/2018 em qualquer idioma, e inventar um nome em ingles para ela produziria uma lei
  // que nao existe. O que se traduz e a frase EM VOLTA dela.
  'Dados pessoais tratados sob a LGPD (Lei 13.709/2018).':
    'Personal data processed under the LGPD (Brazilian Law 13.709/2018).',
  'O aviso de privacidade está acima, em': 'The privacy notice is above, under',
  'Desenvolvido por': 'Built by',

  // O ROTULO DO LINK DE PRIVACIDADE, e ele mora AQUI e nao em cada produto porque virou
  // PADRAO DA PLATAFORMA em 08/09/2026, por ordem dele: "Seus dados e a LGPD (ESSE TEXTO
  // COMO PADRAO DO LINK PARA MOSTRAR)".
  //
  // O TEXTO E IDENTICO EM TODO PRODUTO, entao traduzi-lo em cada `en.ts` de app seria a
  // mesma frase em N lugares. Medido em 08/09/2026: o VOE traduzia e o medicina nao, e os
  // dois mostravam o mesmo rotulo em portugues na mesma posicao da mesma tela.
  //
  // `LGPD` NAO SE TRADUZ: e a sigla da lei brasileira, e ela e a mesma em qualquer idioma.
  'Seus dados e a LGPD': 'Your data and the LGPD',
  'uma plataforma': 'a platform by',

  // Os dois erros do retorno do Google. Eles dizem O QUE FAZER AGORA, e nao apenas o que
  // falhou, e a traducao mantem a saida junto do problema.
  'A entrada com o Google foi cancelada. Você pode tentar de novo ou entrar com e-mail e senha.':
    'Google sign-in was cancelled. You can try again or sign in with email and password.',
  'A entrada com o Google não foi concluída. Tente de novo.':
    'Google sign-in did not complete. Please try again.',
  // O NOME ACESSÍVEL DA MARCA, que saía em português com a tela em inglês (inventário de botões
  // de 11/09/2026, decisão do fundador em enquete). "Entrar" já estava traduzido acima.
  'abrir o site da plataforma em nova aba': 'open the platform website in a new tab',
};
